/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".no-style[_ngcontent-%COMP%]{border:none;background:0 0;box-shadow:none;padding:0}.btn[_ngcontent-%COMP%]{height:31px;padding:0 22px;font:300 15px/29px 'Open Sans',Helvetica,Arial,sans-serif;cursor:pointer}\n/*# sourceMappingURL=button.component.css.map*/"];
export { styles as styles };
